<div> 
    <div>{{serviceName}}</div>
    <div class="serviceId">{{serviceId}}</div> 
</div>
 